const SETUNITS = (state, list) => {
  state.units = list
}

const SETPROFILES = (state, list) => {
  state.profiles = list
}

const SETUSERS = (state, list) => {
  state.users = list
}

const SETPERMISSAOUNI = (state, list) => {
  state.permissaoUni = list
}

const SETPERMISSAOSERV = (state, list) => {
  state.permissaoServ = list
}

const SETUSERLISTDOWNLOAD = (state) => {
  state.userListDownload += 1
}

export default {
  SETUNITS,
  SETPROFILES,
  SETUSERS,
  SETPERMISSAOUNI,
  SETPERMISSAOSERV,
  SETUSERLISTDOWNLOAD
}
